<template>
    <div class="levels">
        <template v-for="(item, index) in numLevelList">
            <img :key="index"
                :src="numIcons[item]"
                :width="widthPercentage"
                :height="numLevelList.length === 1 ? '100%' : 'auto'"
            >
        </template>
    </div>
</template>

<script>
export default {
    name: 'level-number',
    props: {
        level: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            numIcons: {
                0: require('@webapp/modules/rewards/assets/images/numbers/0.webp'),
                1: require('@webapp/modules/rewards/assets/images/numbers/1.webp'),
                2: require('@webapp/modules/rewards/assets/images/numbers/2.webp'),
                3: require('@webapp/modules/rewards/assets/images/numbers/3.webp'),
                4: require('@webapp/modules/rewards/assets/images/numbers/4.webp'),
                5: require('@webapp/modules/rewards/assets/images/numbers/5.webp'),
                6: require('@webapp/modules/rewards/assets/images/numbers/6.webp'),
                7: require('@webapp/modules/rewards/assets/images/numbers/7.webp'),
                8: require('@webapp/modules/rewards/assets/images/numbers/8.webp'),
                9: require('@webapp/modules/rewards/assets/images/numbers/9.webp'),
            },
        };
    },
    computed: {
        numLevelList() {
            const levelList = this.level.toString().split('');

            return levelList.length > 0 ? levelList : [0];
        },
        widthPercentage() {
            return this.numLevelList.length > 1 ? (Math.floor((100 / this.numLevelList.length)) + '%') : 'auto';
        },
    },
};
</script>

<style lang="scss" scoped>
.levels {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>